import React from 'react'
import BreadcrumbGroup from '@cloudscape-design/components-themed/breadcrumb-group'

// https://cloudscape.design/components/breadcrumb-group
export function RadBreadcrumbGroup ({ ...rest }) {
  return (
    <BreadcrumbGroup {...rest} />
  )
}
